import { render, staticRenderFns } from "./AdminSuperDocumentManager.vue?vue&type=template&id=98c695c4&lang=pug&"
import script from "./AdminSuperDocumentManager.vue?vue&type=script&lang=js&"
export * from "./AdminSuperDocumentManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports